import cookies from './util.cookies'

export const getToken = () => {
  return cookies.get('token')
}

export const setToken = token => {
  cookies.set('token', token, { expires: 30 })
}

export const removeToken = () => {
  cookies.remove('token')
}

export default {
  getToken,
  setToken,
  removeToken
}
